var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, TableCell, Tooltip } from "@mui/material";
const containerBoxSxProps = (align, isSorted) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: align && align === "right" ? "end" : "start",
    gap: "6px",
    "&:hover": {
        "& .svg-inline--fa": {
            opacity: isSorted ? 1 : .5
        }
    }
});
const iconBoxSxProps = (isSorted) => ({
    cursor: "pointer",
    color: "action.active",
    "& .svg-inline--fa": {
        transition: "opacity .3s ease-in-out",
        opacity: isSorted ? 1 : 0
    }
});
export const SortableTableHeadCell = (props) => {
    const { children, isReversedSort, loading, onSort, dataTrackingId } = props, tableCellProps = __rest(props, ["children", "isReversedSort", "loading", "onSort", "dataTrackingId"]);
    return (_jsx(TableCell, Object.assign({}, tableCellProps, { sx: Object.assign({}, props.sx), variant: "head", "data-tracking-id": dataTrackingId, children: _jsxs(Box, { sx: containerBoxSxProps(tableCellProps.align, typeof isReversedSort === "boolean"), children: [children && (_jsx(Box, { onClick: () => !loading && onSort(), sx: { cursor: "pointer" }, children: children })), _jsx(Tooltip, { title: "Sort", children: _jsx(Box, { onClick: () => !loading && onSort(), sx: iconBoxSxProps(typeof isReversedSort === "boolean"), children: isReversedSort ?
                            _jsx(FontAwesomeIcon, { icon: ["far", "arrow-up"] }) :
                            _jsx(FontAwesomeIcon, { icon: ["far", "arrow-down"] }) }) })] }) })));
};
export default SortableTableHeadCell;
//# sourceMappingURL=SortableTableHeadCell.js.map